// EasyOrder Custom Start:
document.addEventListener('easyorder_popup_updated', function(){
	
  const pvb_check = document.querySelector('.pvb_done')
  
  if(pvb_check) {
	  return;
  };
	
	
  const easyProcessingText = document.querySelector('#easyorder-popup-holder .easyorder-loader2 .header-popup-result'),
        easyResultText = document.querySelector('#easyorder-popup-holder .easyorder-popup-result2 .header-popup-result'),
        easyResultText_line2 = document.querySelector('#easyorder-popup-holder .easyorder-popup-result2 .text-popup-result'),
        easyTaxesField =  document.querySelector('.easyorder-popup-content .easyorder-main_fields div:nth-child(15) .easyorder-head_field');

  

  if(easyProcessingText){
    easyProcessingText.textContent = "Processing your quote request...";
  }
  if(easyResultText){
    easyResultText.textContent = "Your request has been submitted.";
  }
  if(easyResultText_line2){
    easyResultText_line2.textContent = "";
  }
  if(easyTaxesField){
    let div = document.createElement('div');
    div.innerHTML = '<p>Taxes will be removed from your quote, if your up-to-date tax exemption is on file with us and matches the “bill to” address provided. If we do not have your tax certificate on file or need further information, a member of our team will reach out to you.</p>';
    div.className = 'easy-taxes-note';
    easyTaxesField.appendChild(div);
  };

  // add id to 1st element in form for scroll to.
  const first_form_element_head_field = document.querySelector('.easyorder-popup-content .easyorder-main_fields div:nth-child(1) .easyorder-head_field')
  if (first_form_element_head_field) {
    first_form_element_head_field.id = 'first_form_element_head_field';
  };

  // add message under header.
  const easyHeader_Inner_div = document.querySelector('.easyorder-popup-content .easyorder-main_header .easyorder-main_header_div .easyorder-main_header_div_inner'); 
  if(easyHeader_Inner_div){
    let div = document.createElement('div');
    div.innerHTML = '<p>Please review your quoted items below and scroll down to complete the quote request form.</p><hr>';
    // append scroll to link
    //if (first_form_element_head_field.id) {
    //  div.innerHTML += '<a href=' + '#' + first_form_element_head_field.id + '>Jump to form.</a>'
    //}
    div.className = 'pvb-rq-sub-heading';

   easyHeader_Inner_div.insertAdjacentElement(
    'afterend',div
	);
  };


  

  // hide totals in footer.
  const hr_before_totals = document.querySelector('.easyorder-popup-content .easyorder-main_fields hr');
  const discount_price_div = document.querySelector('#nm_eorder_discount_price_div');
  const footer_total = document.querySelector('#nm_eorder_footer_total').parentElement.parentElement;
  const total_price = document.querySelector('#nm_eorder_total_price').parentElement.parentElement;

  let pvb_hide_footer_totals = document.createElement('div');
  pvb_hide_footer_totals.className = 'pvb_hide_footer_totals';

  hr_before_totals.insertAdjacentElement(
   'afterend',pvb_hide_footer_totals
  );
  
  pvb_hide_footer_totals.appendChild(discount_price_div);
  pvb_hide_footer_totals.appendChild(footer_total);
  pvb_hide_footer_totals.appendChild(total_price);

  const contact_header = document.querySelector('.easyorder-popup-content .easyorder-main_fields div:nth-child(1)');
  const contact_fname = document.querySelector('.easyorder-popup-content .easyorder-main_fields div:nth-child(2)');
  const contact_lname = document.querySelector('.easyorder-popup-content .easyorder-main_fields div:nth-child(3)');

  if(contact_header){
    let easy_contact_name = document.createElement('div');
    easy_contact_name.className = 'easy_contact_name';

  contact_header.insertAdjacentElement(
    'afterend',easy_contact_name
	);

  easy_contact_name.appendChild(contact_fname);
  easy_contact_name.appendChild(contact_lname);
  
  };
  
  
  // move city,state,zip into a div that is flexed under the address line for bill to and ship to
  const	bill_address_line = document.querySelector('.easyorder-popup-content .easyorder-main_fields div:nth-child(8)');
  const	bill_address_city = document.querySelector('.easyorder-popup-content .easyorder-main_fields div:nth-child(9)');
  const	bill_address_state = document.querySelector('.easyorder-popup-content .easyorder-main_fields div:nth-child(10)');  
  const	bill_address_zip = document.querySelector('.easyorder-popup-content .easyorder-main_fields div:nth-child(11)');
  
  const	ship_address_line = document.querySelector('.easyorder-popup-content .easyorder-main_fields div:nth-child(18)');
  const	ship_address_city = document.querySelector('.easyorder-popup-content .easyorder-main_fields div:nth-child(19)');
  const	ship_address_state = document.querySelector('.easyorder-popup-content .easyorder-main_fields div:nth-child(20)');  
  const	ship_address_zip = document.querySelector('.easyorder-popup-content .easyorder-main_fields div:nth-child(21)');
  
  if(bill_address_line){
  
  let easy_bill_city_state_zip = document.createElement('div');
  easy_bill_city_state_zip.className = 'easy_bill_city_state_zip';
  
  bill_address_line.insertAdjacentElement(
    'afterend',easy_bill_city_state_zip
	);
  
  easy_bill_city_state_zip.appendChild(bill_address_city);
  easy_bill_city_state_zip.appendChild(bill_address_state);
  easy_bill_city_state_zip.appendChild(bill_address_zip);
  
  };
  
  if(ship_address_line){
  
  let easy_ship_city_state_zip = document.createElement('div');
  easy_ship_city_state_zip.className = 'easy_ship_city_state_zip';
  
  ship_address_line.insertAdjacentElement(
    'afterend',easy_ship_city_state_zip
	);
  
  easy_ship_city_state_zip.appendChild(ship_address_city);
  easy_ship_city_state_zip.appendChild(ship_address_state);
  easy_ship_city_state_zip.appendChild(ship_address_zip);
  
  };

  // add marker so if event fires again things stay good.
  let easyform_form = document.querySelector('.easyorder-popup-content'); 
  let pvb_done = document.createElement('div');
  pvb_done.className = "pvb_done";
   easyform_form.insertAdjacentElement(
    'afterend',pvb_done
	);
  
  
});
// EasyOrder Custom Finish